import type { EditorSelectionSurface } from '../state/types';

export type ArrowKeyMoveIntent = 'canvas-position' | 'timeline-time';

interface GetArrowKeyMoveIntentParams {
  activeSelectionSurface: EditorSelectionSurface;
  key: string;
  altKey: boolean;
}

export const getArrowKeyMoveIntent = ({
  activeSelectionSurface,
  key,
  altKey,
}: GetArrowKeyMoveIntentParams): ArrowKeyMoveIntent | null => {
  const isHorizontal = key === 'ArrowLeft' || key === 'ArrowRight';

  if (activeSelectionSurface === 'canvas') {
    return 'canvas-position';
  }

  if (activeSelectionSurface === 'timeline') {
    if (isHorizontal && !altKey) {
      return 'timeline-time';
    }

    if (isHorizontal && altKey) {
      return 'canvas-position';
    }

    return null;
  }

  if (isHorizontal && !altKey) {
    return 'timeline-time';
  }

  return 'canvas-position';
};
